<div class="register-layout">
  <div class="row form-layout">
    <div class="col-md-10 form position-relative">
      <div>
        <div class="form-label">
          <h2 class="dashboard-heading">Institution</h2>
        </div>

        <div class="form-label mt-4">
          <h2 class="dashboard-sub-heading">General</h2>
        </div>
        <hr />

        <div class="mt-3">
          <form #myForm="ngForm" class="row g-3" [formGroup]="instForm" id="instForm" novalidate
                [ngClass]="loading ? 'blur-background' : ''">
            <div *ngIf="loading" class="position-absolute top-50 start-100 translate-middle vstack"
                 style="z-index: 1000">
              <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <div class="loading-text">Loading...</div>
            </div>
            <div class="col-md-6 text-start">
              <label for="institutionCode" class="form-label">Institution Code</label>
              <input type="text" class="form-control" id="institutionCode"
                     (ngModelChange)="$event && checkInstCode($event)" formControlName="institutionCode"
                     [readonly]="readOnlyValue" [ngClass]="{
                  'is-invalid':
                    addInstitutionSubmitted &&
                    formInstControl['institutionCode'].errors
                }" />
              <div *ngIf="
                  addInstitutionSubmitted &&
                  formInstControl['institutionCode'].errors
                " class="invalid-feedback">
                <div *ngIf="formInstControl['institutionCode'].errors['required']">
                  Institution code is required
                </div>
<!--                email?????-->
                <div *ngIf="formInstControl['institutionCode'].errors['email']">
                  Institution code is not valid
                </div>
                <div *ngIf="
                    formInstControl['institutionCode'].errors['alreadyExist']
                  ">
                  Institution code already exists
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start">
              <label for="institutionName" class="form-label">Institution Name</label>
              <input type="text" class="form-control" id="institutionName" formControlName="institutionName" [ngClass]="{
                  'is-invalid':
                    addInstitutionSubmitted &&
                    formInstControl['institutionName'].errors
                }" />
              <div *ngIf="
                  addInstitutionSubmitted &&
                  formInstControl['institutionName'].errors
                " class="invalid-feedback">
                <div *ngIf="formInstControl['institutionName'].errors['required']">
                  Institution name is required
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start">
              <label for="institutionAddress" class="form-label">Address</label>
              <input type="text" class="form-control" id="institutionAddress" formControlName="institutionAddress"
                     [ngClass]="{
                  'is-invalid':
                    addInstitutionSubmitted &&
                    formInstControl['institutionAddress'].errors
                }" />
              <div *ngIf="
                  addInstitutionSubmitted &&
                  formInstControl['institutionAddress'].errors
                " class="invalid-feedback">
                <div *ngIf="
                    formInstControl['institutionAddress'].errors['required']
                  ">
                  Address is required
                </div>
              </div>
            </div>
            <div class="col-md-6 text-start">
              <label for="contactNo" class="form-label">Contact Number</label>
              <div class=" row d-flex">
              <ngx-intl-tel-input
                    formControlName="contactNo"
                    *ngIf="allowedCountryCodes.length > 0"
                    [enablePlaceholder]="true"
                    [searchCountryFlag]="true"
                    [separateDialCode]="true"
                    [maxLength]="15"
                    [phoneValidation]="true"
                    [enableAutoCountrySelect]="true"
                    [selectFirstCountry]="false"
                    [onlyCountries]="allowedCountryCodes"
                  >
                  </ngx-intl-tel-input>
              </div>
            </div>

            <!-- <div class="col-md-6 text-start">
              <label for="institutionFaxNo" class="form-label">Fax Number</label>
              <input type="text" class="form-control" id="institutionFaxNo" formControlName="institutionFaxNo"
                [ngClass]="{
                  'is-invalid':
                    addInstitutionSubmitted &&
                    formInstControl['institutionFaxNo'].errors
                }" />
              <div *ngIf="
                  addInstitutionSubmitted &&
                  formInstControl['institutionFaxNo'].errors
                " class="invalid-feedback">
                <div *ngIf="formInstControl['institutionFaxNo'].errors['pattern']">
                  Fax number is not valid
                </div>
              </div>
            </div> -->
            <div class="col-md-6 text-start">
              <label for="institutionEmail" class="form-label">Email address</label>
              <input type="text" class="form-control" id="institutionEmail" formControlName="institutionEmail"
                     [ngClass]="{
                  'is-invalid':
                    addInstitutionSubmitted &&
                    formInstControl['institutionEmail'].errors
                }" />
              <div *ngIf="
                  addInstitutionSubmitted &&
                  formInstControl['institutionEmail'].errors
                " class="invalid-feedback">
                <div *ngIf="formInstControl['institutionEmail'].errors['required']">
                  Email is required
                </div>
                <div *ngIf="formInstControl['institutionEmail'].errors['email']">
                  Email is not valid
                </div>
              </div>
            </div>
            <div class="form-label mt-4">
              <h2 class="dashboard-sub-heading">Configuration</h2>
            </div>
            <hr class="mt-0" />
            <div class="col-md-6 mt-2">
<!--              add fintec trade api-->
              <div class="form-label add-form-checkBox" style="padding: 10px">
                <input type="checkbox" id="FixApiEnableCheck" ng-model="check" formControlName="FixApiEnableCheck" />
                Fix API enable
              </div>
              <div class="form-label add-form-checkBox" style="padding: 10px">
                <input type="checkbox" id="AccountApiEnableCheck" ng-model="check"
                       formControlName="AccountApiEnableCheck" />
                Backoffice API enable
              </div>
              <div class="form-label add-form-checkBox" style="padding: 10px">
                <input type="checkbox" id="DwmEnableCheck" ng-model="check" formControlName="DwmEnableCheck"/>
                DWM enable
              </div>
            </div>
            <div class="col-md-6 mt-2">
              <div class="form-label add-form-checkBox" style="padding: 10px">
                <input type="checkbox" id="DepositAutoEnableCheck" ng-model="check"
                       formControlName="DepositAutoEnableCheck" />
                Deposit Auto Approve Enable
              </div>
              <div class="form-label add-form-checkBox" style="padding: 10px">
                <input type="checkbox" id="WithdrawAutoEnableCheck" ng-model="check"
                       formControlName="WithdrawAutoEnableCheck" />
                Withdraw Auto Approve Enable
              </div>
              <div class="form-label add-form-checkBox" style="padding: 10px">
                <input type="checkbox" id="bypassBuyingPower" ng-model="check"
                       formControlName="bypassBuyingPower" />
                Bypass Buying Power Enable
              </div>
            </div>

            <div class="form-label mt-4">
              <h2 class="dashboard-heading">Keys</h2>
            </div>
            <hr style="margin-top: 0px" />


            <div class="row mt-4">
              <div class="col-md-12 text-start">
                <label for="publicKey" class="form-label mb-2" style="font-weight: bold">Public Key</label>
                <textarea type="text" class="form-control" id="publicKey" formControlName="publicKey" [ngClass]="{
                    'is-invalid':
                      addInstitutionSubmitted &&
                      formInstControl['publicKey'].errors
                  }"></textarea>
                <div *ngIf="
                    addInstitutionSubmitted &&
                    formInstControl['publicKey'].errors
                  " class="invalid-feedback">
                  <div *ngIf="formInstControl['publicKey'].errors['required']">
                    Public Key is required
                  </div>
                </div>
              </div>
            </div>

            <div class="row mt-4">
              <div class="col-md-6 text-start">
                <label for="appKey" class="form-label mb-2" style="font-weight: bold">App Key</label>
                <div class="input-group">
                  <input type="text" class="form-control" id="appKey" formControlName="appKey"
                         placeholder="XXXXX-XXXXX-XXXXX-XXXXX-XXXXX" [ngClass]="{
                    'is-invalid':
                      addInstitutionSubmitted &&
                      formInstControl['appKey'].errors
                  }"/>
                  <div class="input-group-append">
                    <button class="btn btn-primary" (click)="generateAppKey()">Generate</button>
                  </div>
                  <div *ngIf="
                  addInstitutionSubmitted && formInstControl['appKey'].errors
                " class="invalid-feedback">
                    <div *ngIf="formInstControl['appKey'].errors['required']">
                      App Key is required
                    </div>
                    <div *ngIf="formInstControl['appKey'].errors['pattern']">
                      Invalid Format
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-md-6 text-start">
                <label for="appSecret" class="form-label mb-2" style="font-weight: bold">App Secret</label>
                <div class="input-group">
                  <input [type]="newPasswordType ? 'text' : 'password'" class="form-control" id="appSecret"
                         formControlName="appSecret" [ngClass]="{
                      'is-invalid':
                        addInstitutionSubmitted &&
                        formInstControl['appSecret'].errors
                    }" placeholder="************" (focus)="onNewPasswordFocus()" (blur)="onNewPasswordBlur()">
                  <div class="input-group-append">
                    <span class="input-group-text" *ngIf="formInstControl['appSecret'].value !=''">
                      <i class="bi" [ngClass]="{
                          'bi-eye-slash': !newPasswordType,
                          'bi-eye': newPasswordType
                        }" (click)="toggleNewPasswordTextType()"></i>
                    </span>
                    <button class="btn btn-primary" (click)="generateAppSecret()">Generate</button>
                  </div>
                  <div *ngIf="
                      addInstitutionSubmitted &&
                      formInstControl['appSecret'].errors
                    " class="invalid-feedback">
                    <div *ngIf="formInstControl['appSecret'].errors['required']">
                      App Secret is required
                    </div>
                    <div *ngIf="formInstControl['appSecret'].errors['invalid']">
                      Invalid App Secret format
                    </div>
                    <div *ngIf="formInstControl['appSecret'].errors['minlength']">
                      App Secret must be at least 10 characters
                    </div>
                    <div *ngIf="formInstControl['appSecret'].errors['maxlength']">
                      App Secret should not too long (20 characters)
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div *ngIf="initialLoading" class="position-absolute top-50 start-50 translate-middle">
        <div class="spinner-border text-primary" style="width: 3rem; height: 3rem" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
    </div>
  </div>
</div>
